import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Button, setOptions, toast} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeader.css';
import {faHospitalUser, faBars, faPipe, faArrowLeft, faCalendars} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Empty from "../utils/Empty";
import DashboardHeaderHelp from "../dialogs/DashboardHeaderHelp";
import DashboardHeaderProfile from "../dialogs/DashboardHeaderProfile";
import DashboardHeaderMenu from "../dialogs/DashboardHeaderMenu";
import DashboardHeaderLocations from "../dialogs/DashboardHeaderLocations";
import DashboardHeaderReset from "../dialogs/DashboardHeaderReset";
import DashboardHeaderPatients from "../dialogs/DashboardHeaderPatients";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeader({Navigation, locale, navigation, user, setUser, dialog, Dialog, width, configuration, token, wss, setLocale, setVisit, setPatient, patient, location, setLocation, setRefresh}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [iconHover, setIconHover] = useState(null);

    const ButtonUpdate = data => {
        Navigation(data);

        const message = {
            type: 'wss',
            path: 'user-ui-navigation',
            action: 'update',
            data: {
                navigation: data
            }
        };
        wsCall(message);
    }

    const ButtonLocation = () => {
        const array = configuration.locations;
        let text = '';
        const locationItem = array.find(item => item.value === location);

        if (locationItem && locationItem.text) {
            text = locationItem.text.charAt(0).toUpperCase() + locationItem.text.slice(1);
        } else if (locationItem && !locationItem.text && location.value) {
            text = locationItem.value.charAt(0).toUpperCase() + locationItem.value.slice(1)
        } else {
            text = configuration.displayName;
        }

        return text;
    }

    const UpdateUserUiNavigation = useCallback(data => {
        if (data.toast){
            toast({message: locale.dashboardHeader.l, color: 'info', display: 'bottom', duration: 1000});
        }
    }, [locale.dashboardHeader.l]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'user-ui-navigation') {
            UpdateUserUiNavigation(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateUserUiNavigation, setWsResponse]);

    useEffect(() => {
        if (user.ui.navigation) {

            Navigation(user.ui.navigation)
        } else if (configuration.options.queue) {

            ButtonUpdate({page:'queue', tab: 'wait'})
        } else if (configuration.options.calendar) {

            ButtonUpdate({page: 'calendar', tab: 'day'})
        }
    }, []);

    return (
        <div className="mbsc-grid cs-dashboard-header-toolbar">
            <div className="mbsc-row">
                <div className="mbsc-col" >
                    <div className={width > 576 ? "mbsc-row cs-dashboard-header-col-start" : "mbsc-row cs-dashboard-header-col-start-xs"}>
                        {width > 576 &&
                            <div className="cs-dashboard-header-logo" style={{backgroundImage: `url(${configuration.logo})`}} />
                        }
                        {navigation.page === 'patient' &&
                            <Button className="cs-dashboard-header-color cs-dashboard-header-cursor mbsc-bold" variant="flat" >
                                {configuration.patients.longName && patient.paternalName && patient.paternalName} {configuration.patients.longName && patient.maternalName && patient.maternalName} {configuration.patients.longName && (patient.paternalName || patient.maternalName) && ', '}{configuration.patients.longName && patient.firstName && patient.firstName} {configuration.patients.longName && patient.middleName && patient.middleName}{!configuration.patients.longName && patient.lastName && patient.lastName}{!configuration.patients.longName && patient.lastName && ', '}{!configuration.patients.longName && patient.firstName && patient.firstName}
                            </Button>
                        }
                        {navigation.page !== 'patient' &&
                            <Button className={configuration.locations.length <= 1 ? "cs-dashboard-header-color cs-dashboard-header-cursor mbsc-bold" : "cs-dashboard-header-color mbsc-bold"} variant="flat" id="dashboardHeaderLocations" onClick={() => Dialog({view: 'dashboardHeaderLocations'})} >
                                {ButtonLocation()}
                            </Button>
                        }
                    </div>
                </div>
                <div className="mbsc-col-auto" >
                    <div className="mbsc-row cs-dashboard-header-col-end">
                        {navigation.page === 'patient' && !Empty(navigation.back) &&
                            <Button onMouseEnter={() => setIconHover('arrow')} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" disabled={navigation.page === 'queue'} title={locale.dashboardHeader.j} className="mbsc-bold cs-dashboard-header-color" onClick={() => Navigation({back: true})} >
                                {width < 768 && '\u00A0'}<FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faArrowLeft} beatFade={iconHover === 'arrow'} /> {width > 768 && <div className="cs-dashboard-header-menu-text">{locale.dashboardHeader.j}</div>}
                            </Button>
                        }
                        {navigation.page === 'patient' && !Empty(navigation.back) &&
                            <Button color="secondary" variant="flat" className="cs-dashboard-header-cursor" >
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faPipe} />
                            </Button>
                        }
                        {configuration.options.queue && (navigation.page !== 'patient' || (navigation.page === 'patient' && Empty(navigation.back))) &&
                            <Button onMouseEnter={() => setIconHover('user')} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" disabled={navigation.page === 'queue'} title={locale.dashboardHeader.h} className="mbsc-bold cs-dashboard-header-color" onClick={() => ButtonUpdate({page: 'queue', tab: 'wait'})} >
                                {width < 768 && '\u00A0'}<FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faHospitalUser} beatFade={iconHover === 'user'} /> {width > 768 && <div className="cs-dashboard-header-menu-text">{locale.dashboardHeader.h}</div>}
                            </Button>
                        }
                        {configuration.options.queue && (navigation.page !== 'patient' || (navigation.page === 'patient' && Empty(navigation.back))) &&
                            <Button color="secondary" variant="flat" className="cs-dashboard-header-cursor" >
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faPipe} />
                            </Button>
                        }
                        {configuration.options.calendar && (navigation.page !== 'patient' || (navigation.page === 'patient' && Empty(navigation.back))) &&
                            <Button onMouseEnter={() => setIconHover('calendars')} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" disabled={navigation.page === 'calendar'} title={locale.dashboardHeader.h} className="mbsc-bold cs-dashboard-header-color" onClick={() => ButtonUpdate({page: 'calendar', tab: 'day'})} >
                                {width < 768 && !configuration.options.queue && '\u00A0'}<FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faCalendars} beatFade={iconHover === 'calendars'} /> {width > 768 && <div className="cs-dashboard-header-menu-text">{locale.dashboardHeader.k}</div>}
                            </Button>
                        }
                        {configuration.options.calendar && (navigation.page !== 'patient' || (navigation.page === 'patient' && Empty(navigation.back))) &&
                            <Button color="secondary" variant="flat" className="cs-dashboard-header-cursor" >
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faPipe} />
                            </Button>
                        }
                        <Button onMouseEnter={() => setIconHover('menu')} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-color"  id="dashboardHeaderMenu" title={locale.dashboardHeader.e} onClick={() => Dialog({view: 'dashboardHeaderMenu'})} >
                            <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faBars} fade={iconHover === 'menu'} />
                        </Button>
                    </div>
                </div>
            </div>
            {dialog.view === 'dashboardHeaderMenu' &&
                <DashboardHeaderMenu
                    dialog={dialog}
                    Dialog={Dialog}
                    locale={locale}
                    user={user}
                    token={token}
                    wss={wss}
                    setUser={setUser}
                    setLocale={setLocale}
                    configuration={configuration}
                    Navigation={Navigation}
                />
            }
            {dialog.view === 'dashboardHeaderLocations' &&
                <DashboardHeaderLocations
                    dialog={dialog}
                    Dialog={Dialog}
                    configuration={configuration}
                    setLocation={setLocation}
                    setRefresh={setRefresh}
                    location={location}
                />
            }
            {dialog.view === 'dashboardHeaderHelp' &&
                <DashboardHeaderHelp
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    width={width}
                />
            }
            {dialog.view === 'dashboardHeaderProfile' &&
                <DashboardHeaderProfile
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    user={user}
                    width={width}
                />
            }
            {dialog.view === 'dashboardHeaderReset' &&
                <DashboardHeaderReset
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    setUser={setUser}
                    width={width}
                />
            }
            {dialog.view === 'dashboardHeaderPatients' &&
                <DashboardHeaderPatients
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    setVisit={setVisit}
                    setPatient={setPatient}
                    width={width}
                />
            }
        </div>
    );
}

export default DashboardHeader;
